module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-245.f9851532.svg";